var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-header"},[_c('div',{staticClass:"left",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("../image/back.png"),"alt":"back"}}),_vm._v("\n    返回\n  ")]),_c('div',{staticClass:"title"},[_vm._v("聊天窗口")])])
}
var staticRenderFns = []

export { render, staticRenderFns }